import { IEntity } from '../types';
import { EntityService } from './EntityService';

export class RiskAppPriorityService extends EntityService<IEntity> {
    constructor() {
        super(`/RiskAppPriorities`);
    }
}